<template>
    <button type="button" class="btn rounded bg-main text-white font-bold focus:ring-0 hover:bg-hoverMain" @click="$router.back()">
        {{ $t('goBack') }}
    </button>
</template>

<script>
    export default {
        name: "GoBackButton"
    }
</script>

<style scoped>

</style>